<template>
  <b-overlay :show="loading">
    <b-card>
      <b-card-text
        class="d-flex flex-column justify-content-center"
        style="height: 20px"
      >
        <b-row>
          <b-col cols="12" xl="5" lg="12" class="self-">
            <span class="font-weight-bold"> {{ text }}: </span>
          </b-col>
          <b-col cols="12" class="align-self-center">
            <span>
              {{ formatToMoney ? formatNumber(quantity) : quantity }}
            </span>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </b-overlay>
</template>

<script>
import { formatNumber } from 'Utils/index.js';

export default {
  name: 'StatsCard',
  props: {
    text: {
      type: String,
      required: true,
    },
    quantity: {
      type: String | Number,
      default: 0,
    },
    color: {
      type: String,
      default: 'primary',
    },
    down: {
      type: Boolean,
      default: false,
    },
    formatToMoney: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatNumber,
  },
};
</script>